/* Picks which admin dashboard to mount.
 *
 *   org admin, Dashboard Overview, filter = "All Branches"  -> OrgOverviewDashboard
 *                                                              (per-branch scorecard)
 *   anything else (a branch selected, or a branch admin)     -> AdminDashboard
 *                                                              (operational, one branch)
 *
 * It also owns the reaction to the header branch dropdown. Only EmployeeList
 * listened for BRANCH_FILTER_CHANGED_EVENT before, so picking a branch in
 * Dashboard Overview left the dashboard showing the previous scope until the
 * next full reload. Keying AdminDashboard on the filter remounts it, so it
 * re-fetches with the new ?branch= — and swapping to/from the org view happens
 * on the same signal.
 */

import React, { useEffect, useState } from "react";

import AdminDashboard from "./AdminDashboard";
import OrgOverviewDashboard from "./OrgOverviewDashboard";
import {
    BRANCH_FILTER_CHANGED_EVENT,
    getOverviewBranchFilter,
    isOrgOverview,
} from "../../utils/branchSession";

const DashboardSwitch = () => {
    const [branchFilter, setBranchFilter] = useState(() => getOverviewBranchFilter());

    useEffect(() => {
        const onBranchFilterChange = () => setBranchFilter(getOverviewBranchFilter());
        window.addEventListener(BRANCH_FILTER_CHANGED_EVENT, onBranchFilterChange);
        return () => window.removeEventListener(BRANCH_FILTER_CHANGED_EVENT, onBranchFilterChange);
    }, []);

    // No branch filter while in overview = "All Branches" = the org view. A
    // branch admin is never in overview mode, so they always get AdminDashboard.
    if (isOrgOverview() && !branchFilter) {
        return <OrgOverviewDashboard />;
    }

    return <AdminDashboard key={branchFilter || "all"} />;
};

export default DashboardSwitch;
